/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Checkin_Call_PlayerInputs */



/**
* | output |
* | --- |
* | "You need to check in to participate." |
*
* @param {Tournament_Checkin_Call_PlayerInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_checkin_call_player = /** @type {((inputs?: Tournament_Checkin_Call_PlayerInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Checkin_Call_PlayerInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vous devez pointer pour participer.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Debe hacer check-in para participar.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Você precisa fazer check-in para participar.")
	if (locale === "it") return /** @type {LocalizedString} */ ("È necessario fare il check-in per partecipare.")
	return /** @type {LocalizedString} */ ("You need to check in to participate.")
});